import React from 'react';
import HeaderMain from '../HeaderMain/HeaderMain';
import './Header.css'

const Header = () => {
    return (
        <div>
            <HeaderMain></HeaderMain>
        </div>
    );
};

export default Header;